import { render, staticRenderFns } from "./distributorMan.vue?vue&type=template&id=0f6a8434&scoped=true&"
import script from "./distributorMan.vue?vue&type=script&lang=js&"
export * from "./distributorMan.vue?vue&type=script&lang=js&"
import style0 from "./distributorMan.vue?vue&type=style&index=0&id=0f6a8434&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6a8434",
  null
  
)

export default component.exports